import React, { useState } from "react";
import { Label } from "@/components/ui/label";
import { Switch } from "@/components/ui/switch";
import { Input } from "@/components/ui/input";
import { Building, Hash } from "lucide-react";

interface InstitutionToggleProps {
  institucion: boolean;
  setInstitucion: (value: boolean) => void;
  nombreInstitucion: string;
  setNombreInstitucion: (value: string) => void;
  numeroInstitucion: string;
  setNumeroInstitucion: (value: string) => void;
  className?: string;
}

const InstitutionToggle = ({
  institucion,
  setInstitucion,
  nombreInstitucion,
  setNombreInstitucion,
  numeroInstitucion,
  setNumeroInstitucion,
  className = "",
}: InstitutionToggleProps) => {
  const [isFocusedNombre, setIsFocusedNombre] = useState(false);
  const [isFocusedNumero, setIsFocusedNumero] = useState(false);

  return (
    <div className={`space-y-4 ${className}`}>
      <div className="flex justify-between w-full items-center rounded-lg py-3 px-4 border border-gray-300 group hover:border-gray-400 transition-all duration-200">
        <div className="flex items-center gap-2">
          <Building className={`h-5 w-5 ${institucion ? "text-blue-600" : "text-gray-400"}`} />
          <Label htmlFor="institucion" className="text-sm font-medium text-gray-700 cursor-pointer">
            ¿Perteneces a una institución?
          </Label>
        </div>
        <Switch
          id="institucion"
          checked={institucion}
          onCheckedChange={() => setInstitucion(!institucion)}
          className="data-[state=checked]:bg-blue-600"
        />
      </div>

      {institucion && (
        <div className="animate-in fade-in-0 duration-300 space-y-4">
          <div className="relative group">
            <Label 
              htmlFor="nombreInstitucion" 
              className={`block text-sm font-medium mb-2 transition-colors duration-200 ${
                isFocusedNombre ? "text-blue-600" : "text-gray-700"
              }`}
            >
              Nombre de la institución <span className="text-red-500">*</span>
            </Label>
            <div className="relative">
              <div className="absolute inset-y-0 left-0 pl-4 flex items-center pointer-events-none">
                <Building className={`h-5 w-5 ${isFocusedNombre ? "text-blue-600" : "text-gray-400"}`} />
              </div>
              <Input
                id="nombreInstitucion"
                type="text"
                className={`w-full pl-12 rounded-lg border ${
                  isFocusedNombre ? "border-blue-500 focus-visible:ring-blue-500" : "border-gray-300"
                } shadow-sm h-12 text-sm placeholder:text-sm placeholder:text-gray-400 transition-all duration-200 focus:outline-none focus-visible:ring-2 focus-visible:ring-opacity-50 group-hover:border-gray-400`}
                required
                value={nombreInstitucion}
                onChange={(e) => setNombreInstitucion(e.target.value)}
                onFocus={() => setIsFocusedNombre(true)}
                onBlur={() => setIsFocusedNombre(false)}
                placeholder="Nombre de la institución"
              />
            </div>
          </div>
          <div className="relative group">
            <Label 
              htmlFor="numeroInstitucion" 
              className={`block text-sm font-medium mb-2 transition-colors duration-200 ${
                isFocusedNumero ? "text-blue-600" : "text-gray-700"
              }`}
            >
              Número de institución (opcional)
            </Label>
            <div className="relative">
              <div className="absolute inset-y-0 left-0 pl-4 flex items-center pointer-events-none">
                <Hash className={`h-5 w-5 ${isFocusedNumero ? "text-blue-600" : "text-gray-400"}`} />
              </div>
              <Input
                id="numeroInstitucion"
                type="text"
                className={`w-full pl-12 rounded-lg border ${
                  isFocusedNumero ? "border-blue-500 focus-visible:ring-blue-500" : "border-gray-300"
                } shadow-sm h-12 text-sm placeholder:text-sm placeholder:text-gray-400 transition-all duration-200 focus:outline-none focus-visible:ring-2 focus-visible:ring-opacity-50 group-hover:border-gray-400`}
                value={numeroInstitucion}
                onChange={(e) => setNumeroInstitucion(e.target.value)}
                onFocus={() => setIsFocusedNumero(true)}
                onBlur={() => setIsFocusedNumero(false)}
                placeholder="Número de institución"
              />
            </div>
          </div>
        </div>
      )}
    </div>
  );
};

export default InstitutionToggle; 